/**
 * active | inactive
 * true   | false = true
 * false  | true = false
 * true   | true = null
 * false  | false = null
 */
export const objectMergeBool = (obj: Record<string, boolean>): boolean | null => {
	const [first, second] = Object.values(obj);

	return first === second ? null : first;
};
